<template>
  <div v-if="show" class="overlay-container" :style="cssVars">
    <div class="overlay"></div>
    <div class="overlay-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Overlay',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    opacity: {
      type: Number,
      default: 0.46
    },
    zIndex: {
      type: Number,
      default: 5
    }
  },
  computed: {
    cssVars() {
      return {
        '--opacity': this.opacity,
        '--z-index': this.zIndex
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.overlay-container {
  position: absolute;
  inset: 0 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-index);

  .overlay {
    position: absolute;
    inset: 0 0 0 0;
    background-color: #212121;
    opacity: var(--opacity);
  }

  .overlay-content {
    position: relative;
  }
}
</style>
